/**
 * Russian plural forms for counters («1 проект», «2 проекта», «5 проектов»).
 */
export function pluralRu(count: number, one: string, few: string, many: string): string {
  const mod100 = Math.abs(count) % 100;
  const mod10 = mod100 % 10;
  if (mod100 >= 11 && mod100 <= 14) return many;
  if (mod10 === 1) return one;
  if (mod10 >= 2 && mod10 <= 4) return few;
  return many;
}

export function projectWord(count: number): string {
  return pluralRu(count, 'проект', 'проекта', 'проектов');
}

export function personWord(count: number): string {
  return pluralRu(count, 'человек', 'человека', 'человек');
}
